const PropTypes = require('prop-types');
const React = require('react');
const moment = require('moment');
const APIRequest = require('components/api_request.js');
const UrlHelpers = require('components/shared/url_helpers.js');

class OrderNote extends React.Component {
  renderCreatedAt() {
    const parsed = moment.unix(this.props.orderNote.created_at.seconds)
    return parsed.format('lll');
  }

  handleDeleteNote = (event) => {
    event.preventDefault();
    const confirmed = confirm(I18n.t('js.orderNotes.confirmDelete'));
    if (!confirmed) { return; }

    APIRequest.V4.destroyJSON(
      UrlHelpers.deleteOrderNotePath,
      {
        order_note_ids: [this.props.orderNote.id],
      }
    );

    this.props.onDeleted(this.props.orderNote);
  }

  render() {
    return (
      <div className="order-note">
        <div className="order-note__header">
          <span className="order-note__timestamp">
            {this.renderCreatedAt()}
          </span>
          <button
            className="order-note__delete"
            type="button"
            onClick={this.handleDeleteNote}
          >
          </button>
        </div>
        <div className="order-note__body">
          {this.props.orderNote.body}
        </div>
      </div>
    );
  }
}

OrderNote.propTypes = {
  orderNote: PropTypes.object.isRequired,
};

module.exports = OrderNote;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/order_notes/order_note.jsx